module.exports = __webpack_public_path__ + "fonts/Lato-Heavy.2ce4d823.woff";